import { useCallback } from 'react';

import { usePageFilterSettings } from 'shared/hooks/usePageFilterSettings';

import { ActiveFilter, PageSettingsKey } from '../Filter.types';

export const useIsAcademicFilterDisabled = (pageKey: PageSettingsKey) => {
  const { isAcademicYearEnabled } = usePageFilterSettings(pageKey);

  const getIsFilterDisabled = useCallback(
    (filterName: ActiveFilter): boolean => {
      return filterName === 'academicYear' && !isAcademicYearEnabled;
    },
    [isAcademicYearEnabled]
  );

  return { getIsFilterDisabled };
};
